import DefaultDialogController from 'utils/notifications/default-dialog-controller';

import template from './terms-confirm-dialog.html';

class TermsConfirmDialogController extends DefaultDialogController {}

export default class TermsConfirmDialogComponent {
  constructor() {
    this.controller = TermsConfirmDialogController;
    this.template = template;
    this.bindings = {
      resolve: '<',
      close: '&',
      dismiss: '&',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/app/components/home/management/components/terms/components/terms-confirm-dialog/terms-confirm-dialog-component.js